import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'antd';
import Translate from 'react-translate-component';

import { logout } from 'actions/userActions';
import { main } from 'constants/routes';

@connect(null, { logout })
export default class RegisrationRedirect extends Component {
    componentDidMount() {
        const { history: { push }, logout } = this.props;

        Modal.confirm({
            title: <Translate content="modal.logoutQuestion" />,
            okText: <Translate content="menu.logout" />,
            okType: 'blue',
            cancelText: <Translate content="modal.cancelModal" />,
            onCancel: () => {
                push(main.path);
            },
            onOk: () => {
                logout();
            },
            className: 'confirm-modal'
        })
    }

    render() {
        return null;
    }
}
